import React from 'react';

const SvgInfoSmall = props => (
  <svg width={17} height={17} {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Additional-request---Edit---Changed-values"
        transform="translate(-104.000000, -727.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g id="Group-3" transform="translate(90.000000, 716.000000)">
          <g id="Group-2">
            <path
              d="M16,19 L14,19 L14,14 L16,14 L16,19 Z M14,12.0057803 C14,11.666665 14.0785249,11.414259 14.2355769,11.2485549 C14.392629,11.0828508 14.6458316,11 14.9951923,11 C15.344553,11 15.5993582,11.0847776 15.7596154,11.2543353 C15.9198726,11.4238929 16,11.6743721 16,12.0057803 C16,12.6685968 15.6650675,13 14.9951923,13 C14.3317275,13 14,12.6685968 14,12.0057803 Z"
              id="info-copy"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgInfoSmall;
